// Slike kalendara u wwwroot/img/kalendari: meseci i praznici su na samim slikama. Isti raspored koristi ThemeImages
// u pogledima (Features/Home/ThemeImages.cs).
const root = '/img/kalendari';

export const sheetImage = (theme: string, month: number): string =>
  `${root}/teme/${theme}/${String(month + 1).padStart(2, '0')}.webp`;

export const miniSprite = (theme: string): string => `${root}/teme/${theme}/mini.webp`;

export const headerImage = (company: string): string => `${root}/zaglavlja/${company}.webp`;
